  
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Clock, ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const WaitingForApproval = () => {
  return (
    <div className="flex-1 flex items-center justify-center px-4 pb-4 min-h-[80vh] bg-background">
      <Card className="w-full max-w-md shadow-lg border-muted/60">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-4">
            <div className="h-16 w-16 bg-primary/10 rounded-full flex items-center justify-center">
              <Clock className="h-8 w-8 text-primary" />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold text-foreground">Pending Approval</CardTitle>
          <CardDescription className="text-base mt-2">
            Your account is currently waiting for administrator approval.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center space-y-6">
          <div className="p-4 bg-muted/30 rounded-lg text-sm text-muted-foreground border">
            <p>
              Thanks for joining! We've received your registration and our administrators have been notified.
              You'll gain full access to the dashboard once your account is approved.
            </p>
          </div>

          <div className="flex flex-col gap-3 pt-2">
            <p className="text-xs text-muted-foreground">
              If you believe this is an error, please contact your church administrator.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default WaitingForApproval;
